<template>
  <form @submit.prevent="sendForm">
    <div class="alert alert-danger" v-if="submitStatus == 'ERROR'">Form error. Try to reload the page and submit again.</div>
    <div class="alert alert-danger" v-if="submitStatus == 'VALIDATION_ERROR'">Please fill in all the fields.</div>
    <div class="alert alert-success" v-if="submitStatus == 'OK'">You message was sent. Thank you.</div>
    <div class="alert alert-success" v-if="submitStatus == 'PENDING'">Please wait, sending.</div>
    <div class="b-form__group">
      <label for="user-name">Your name</label>
      <input v-model.trim="$v.userName.$model" :class="{error: $v.userName.$error}" type="text" class="b-form__control" id="user-name" name="user-name" />
      <div class="b-form__control-error" v-if="!$v.userName.required">Name is required</div>
      <div class="b-form__control-error" v-if="!$v.userName.minLength">Name must have at least {{ $v.userName.$params.minLength.min }} letters</div>
    </div>

    <div class="b-form__group">
      <label for="user-email">Your email</label>
      <input v-model.trim="$v.userEmail.$model" :class="{error: $v.userEmail.$error}" type="email" class="b-form__control" id="user-email" name="user-email" />
      <div class="b-form__control-error" v-if="!$v.userEmail.required">Email is required</div>
      <div class="b-form__control-error" v-if="!$v.userEmail.email">Email must be a valid format</div>
    </div>

    <div class="b-form__group">
      <label for="subject">Subject</label>
      <textarea name="subject" v-model.trim="$v.subject.$model" :class="{error: $v.subject.$error}" id="subject" class="b-form__control" cols="40" rows="10"></textarea>
      <div class="b-form__control-error" v-if="!$v.subject.required">Subject is required</div>
      <div class="b-form__control-error" v-if="!$v.subject.minLength">Subject must have at least {{ $v.subject.$params.minLength.min }} letters</div>
    </div>

    <input type="hidden" name="contact_number">
    <input type="hidden" name="platform_version">
    <input type="hidden" name="platform_name">
    <input type="hidden" name="platform_os_version">
    <input type="hidden" name="platform_os_family">
    <input type="hidden" name="platform_description">
    <input type="submit" value="Submit" class="b-button b-button--primary">
  </form>
</template>

<script>
import emailjs from 'emailjs-com';
import { required, minLength, email} from 'vuelidate/lib/validators';
import platform from 'platform';

export default {
  name: "ContactForm",
  data: function() {
    return {
      userName: '',
      userEmail: '',
      subject: '',
      submitStatus: null
    };
  },
  methods: {
    sendForm: function(e) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = 'VALIDATION_ERROR';
      }
      else {
        this.submitStatus = 'PENDING';
        e.target.contact_number.value = Math.random() * 100000 | 0;
        e.target.platform_version.value = platform.version;
        e.target.platform_name.value = platform.name;
        e.target.platform_os_family.value = platform.os.family;
        e.target.platform_os_version.value = platform.os.version;
        e.target.platform_description.value = platform.description;
        console.log(platform.os);
        console.log(platform.version);
        console.log(platform.name);
        console.log(platform.description);
        emailjs.sendForm('gmail', 'new_support_request', e.target, 'user_sNehHXAvMU64vBhyxzEfY')
          .then((result) => {
            this.submitStatus = 'OK';
            console.log(result);
            this.userName = '';
            this.userEmail = '';
            this.subject = '';
            this.$v.$reset();
          }, (error) => {
            this.submitStatus = 'ERROR';
            console.log(error);
          });
      }
    }
  },
  validations: {
    userName: {
      minLength: minLength(3),
      required
    },
    userEmail: {
      email,
      required
    },
    subject: {
      minLength: minLength(10),
      required
    }
  }
};
</script>